import { setupStore, type AppStore } from "./store";

// Seems to be caused by some kind of circular dependency...
let store: AppStore | null = null;

// Do not access store directly - it will cause issues with storybook
export function getStore() {
  if (!store) {
    store = setupStore();
  }
  return store;
}
